export default "__VITE_ASSET__DBFsy9H1__"